import { render, staticRenderFns } from "./AlertComments.vue?vue&type=template&id=52b42b76&scoped=true"
import script from "./AlertComments.vue?vue&type=script&lang=js"
export * from "./AlertComments.vue?vue&type=script&lang=js"
import style0 from "./AlertComments.vue?vue&type=style&index=0&id=52b42b76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b42b76",
  null
  
)

export default component.exports